export function isDownloadingData({ companyInfo }) {
  return companyInfo.isDownloadingData;
}

export function primaryContact({ companyInfo }) {
  return companyInfo.primaryContact;
}
